// Return text as lowercase, replacing all special charaters with a dash
// Return a mnemonic error if input text is undefined
type TTextToJumpLinkOptions = {
	allowApostrophe?: boolean;
};

const getNormalizationRegex = (allowApostrophe: boolean): RegExp => (allowApostrophe ? /[^'a-z0-9]+/g : /[^a-z0-9]+/g);

const trimEdgeDashes = (value: string): string => {
	let start = 0;
	let end = value.length - 1;

	while (start <= end && value[start] === '-') {
		start += 1;
	}

	while (end >= start && value[end] === '-') {
		end -= 1;
	}

	return value.slice(start, end + 1);
};

export const textToJumpLink = (text: string | undefined | null, options: TTextToJumpLinkOptions = {}): string => {
	if (!text) return '';
	// Normalize text to lowercase
	const normalizedText = text.toLowerCase();
	// Replace all special characters with a dash
	const normalizationRegex = getNormalizationRegex(!!options.allowApostrophe);
	const jumpLinkText = normalizedText.replace(normalizationRegex, '-');
	// Remove any leading or trailing dashes
	return trimEdgeDashes(jumpLinkText);
};
export const textToJumpLinkShorten = (text: string | undefined | null, length: number): string => {
	let label = text;
	if (text?.length && text?.length > length) {
		label = text.slice(0, length);
	}
	return textToJumpLink(label);
};
